module.exports = __webpack_public_path__ + "static/media/creo kitchens.7b635303.png";